import React, { useState } from "react";

export default function Iscriviti() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    
    // Simulazione di invio (il cliente gestirà la logica backend)
    setTimeout(() => {
      setMessage("Grazie per la tua iscrizione! La newsletter sarà presto attiva.");
      setEmail("");
      setLoading(false);
    }, 1000);
  };

  return (
    <section className="bg-gray-50 py-16" id="iscriviti">
      <div className="container mx-auto px-4">
        {/* Titolo centrato con animazione */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8" data-aos="zoom-in">
            <h2 className="text-3xl md:text-4xl font-bold" style={{ color: '#233872' }}>
              Unisciti alla community
            </h2>
          </div>
        </div>
        {/* Descrizione su tutta la larghezza del container, centrata e animata */}
        <div className="text-gray-600 mb-12 text-base md:text-lg leading-relaxed text-center" data-aos="zoom-in">
          Ricevi direttamente nella tua casella di posta elettronica le ultime offerte, le promozioni esclusive e tutte le novità dei prodotti e dei nostri punti vendita di Apricena, Foggia, Barletta, Bari, Fasano e Maglie, oltre a consigli utili, aggiornamenti settimanali e sconti riservati solo ai nostri clienti iscritti
        </div>
        {/* Formulario centrato e animato */}
        <div className="max-w-2xl mx-auto" data-aos="zoom-in">
          <form className="flex flex-col sm:flex-row w-full" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Inserisci qui il tuo indirizzo email"
              className="flex-1 px-4 py-3 rounded-t-lg sm:rounded-t-none sm:rounded-l-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all placeholder-gray-400 text-gray-700 text-base"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <button
              type="submit"
              className="rounded-b-lg sm:rounded-b-none sm:rounded-r-lg bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3 flex items-center justify-center transition-colors duration-200 text-base w-full sm:w-auto sm:-ml-px"
              disabled={loading}
            >
              {loading ? "Invio..." : "Iscriviti"}
            </button>
          </form>
          {message && (
            <div className="mt-4 text-center text-sm" style={{ color: message.includes("Grazie") ? "green" : "red" }}>
              {message}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
